<template>
    <div
        v-if="active"
        class="mp-dock-drop-overlay mp-dock-drop-overlay--capturing"
    >
        <div
            v-for="(z, index) in paintOrderedDropZones"
            :key="zoneDomKey(z, index)"
            class="mp-dock-drop-target"
            :class="[
                `mp-dock-drop-target--${z.zone}`,
                {
                    'mp-dock-drop-target--active': isZoneActive(z),
                    'mp-dock-drop-target--root-edge': z.tier === 'root',
                },
            ]"
            :style="zoneStyle(z)"
            @pointerenter="setHover(z)"
            @pointerup.stop.prevent="onDrop(z)"
        >
            <span v-if="isZoneActive(z)" class="mp-dock-drop-hint">
                {{ z.hint }}
            </span>
        </div>
        <div
            v-if="ghost"
            class="mp-dock-drag-ghost"
            :style="{ left: ghost.x + 'px', top: ghost.y + 'px' }"
        >
            {{ ghost.title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'DockDropOverlay',

    props: {
        active: { type: Boolean, default: false },
        dropZones: { type: Array, default: () => [] },
        ghost: { type: Object, default: null },
        hoverZoneKey: { type: String, default: null },
    },

    emits: ['drop', 'hover'],

    computed: {
        allowedDropZones() {
            return this.dropZones.filter((z) => z.allowed === true);
        },

        /** Center first, then edges; root edge bars above host sub-zones. */
        paintOrderedDropZones() {
            const zoneOrder = { center: 0, left: 1, top: 2, right: 3, bottom: 4 };
            const tierOrder = { host: 0, root: 1 };
            return [...this.allowedDropZones].sort((a, b) => {
                const za = zoneOrder[a.zone] ?? 5;
                const zb = zoneOrder[b.zone] ?? 5;
                if (za !== zb) return za - zb;
                const ta = tierOrder[a.tier] ?? 0;
                const tb = tierOrder[b.tier] ?? 0;
                return ta - tb;
            });
        },
    },

    methods: {
        zoneKey(z) {
            if (z.tier === 'root') return `root::${z.region}`;
            return `${z.nodeId}::${z.zone}`;
        },

        zoneDomKey(z, index) {
            return `${this.zoneKey(z)}-${index}`;
        },

        isZoneActive(z) {
            return this.hoverZoneKey === this.zoneKey(z);
        },

        zoneStyle(z) {
            const r = z.zoneRect || z.rect;
            if (!r) return { display: 'none' };
            return {
                position: 'fixed',
                left: `${r.left}px`,
                top: `${r.top}px`,
                width: `${r.width}px`,
                height: `${r.height}px`,
                pointerEvents: 'auto',
            };
        },

        setHover(z) {
            this.$emit('hover', { key: this.zoneKey(z), zone: z });
        },

        onDrop(z) {
            if (z.allowed !== true) return;
            this.$emit('drop', z);
        },
    },
};
</script>
